<template>
  <div
    class="aria-announcer"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    {{ message }}
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const message = ref('')

function announce(text: string): void {
  message.value = ''
  requestAnimationFrame(() => {
    message.value = text
  })
}

defineExpose({ announce })
</script>

<style scoped lang="scss">
@use '@/styles/design-tokens' as *;

.aria-announcer {
  @include sr-only;
}
</style>
